// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Welcome.css */
.welcome-section {
    background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
    min-height: calc(100vh - 5rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
}

.welcome-content {
    max-width: 800px;
    text-align: center;
    color: var(--white);
}

.welcome-title {
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
    line-height: 1.2;
}

.welcome-title .highlight {
    color: red;
}

.welcome-text {
    font-size: 1.25rem;
    line-height: 1.75;
    margin-bottom: 2rem;
    opacity: 0.9;
}

.try-now-button {
    background-color: var(--secondary);
    color: var(--white);
    font-size: 1.25rem;
    font-weight: 600;
    padding: 1rem 2.5rem;
    border-radius: 0.5rem;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
}

@media (max-width: 640px) {
    .welcome-title {
        font-size: 2rem;
    }

    .welcome-text {
        font-size: 1rem;
    }

    .try-now-button {
        font-size: 1rem;
        padding: 0.75rem 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Welcome.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,6EAA6E;IAC7E,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;AACJ","sourcesContent":["/* Welcome.css */\n.welcome-section {\n    background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);\n    min-height: calc(100vh - 5rem);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n}\n\n.welcome-content {\n    max-width: 800px;\n    text-align: center;\n    color: var(--white);\n}\n\n.welcome-title {\n    font-size: 3rem;\n    font-weight: bold;\n    margin-bottom: 1.5rem;\n    line-height: 1.2;\n}\n\n.welcome-title .highlight {\n    color: red;\n}\n\n.welcome-text {\n    font-size: 1.25rem;\n    line-height: 1.75;\n    margin-bottom: 2rem;\n    opacity: 0.9;\n}\n\n.try-now-button {\n    background-color: var(--secondary);\n    color: var(--white);\n    font-size: 1.25rem;\n    font-weight: 600;\n    padding: 1rem 2.5rem;\n    border-radius: 0.5rem;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    transition: background-color 0.3s ease;\n}\n\n@media (max-width: 640px) {\n    .welcome-title {\n        font-size: 2rem;\n    }\n\n    .welcome-text {\n        font-size: 1rem;\n    }\n\n    .try-now-button {\n        font-size: 1rem;\n        padding: 0.75rem 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
